import { withInstall } from '../../utils/install';
import Segmented from './src/segmented.vue';

export const ISegmented = withInstall(Segmented); // 增加类型

export default ISegmented;
